/**
 * Classify the WebView cache that accompanies a native secure credential.
 *
 * iOS Keychain credentials can survive reinstall while this cache is deleted.
 * A credential without a valid user/company identity must not be silently
 * refreshed. Missing/corrupt permissions are repairable after refresh and must
 * not force an otherwise valid session back through password login.
 *
 * @param {Storage} storage
 * @returns {'complete'|'repairable'|'orphaned'|'unavailable'}
 */
export function nativeAuthContextState(storage) {
  let userRaw
  let domainRaw
  let permissionsRaw
  try {
    userRaw = storage.getItem('user')
    domainRaw = storage.getItem('domain')
    permissionsRaw = storage.getItem('permissions')
  } catch {
    // Storage availability is transient and says nothing about whether the
    // secure credential is orphaned. Never destroy Keychain state on I/O failure.
    return 'unavailable'
  }

  try {
    const user = JSON.parse(userRaw || 'null')
    const domain = JSON.parse(domainRaw || 'null')
    const hasIdentity = Boolean(
      user && typeof user === 'object' && user.id
      && domain && typeof domain === 'object' && domain.id
    )
    if (!hasIdentity) return 'orphaned'

    try {
      const permissions = JSON.parse(permissionsRaw || 'null')
      return Array.isArray(permissions) ? 'complete' : 'repairable'
    } catch {
      return 'repairable'
    }
  } catch {
    return 'orphaned'
  }
}
